import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {first} from "rxjs/operators";

import {MatDialog} from "@angular/material/dialog";
import {NotificationService} from "./service/notification.service";
import {Notifications} from "./model/notifications";
import {Page} from "../models/page";
import {Notification} from "./model/notification";
import {DeleteNotificationDialogComponent} from "./dialog/deleteNotificationDialog.component";


@Component({
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss',]
})


export class NotificationComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private notificationService: NotificationService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Notifications');
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }


        this.notificationService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit).pipe(first())
            .subscribe((res: Notifications) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    showConfirmNotificationDeleteDialog(event: Notification) {
        this.deleteDialogRef = this._matDialog.open(DeleteNotificationDialogComponent, {
            panelClass: 'delete-notification-dialog',
            data      : {
                action : 'show',
                event: event,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.notificationService.delete(event.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
